import { CheckInsMyMSCResponse } from '@msc-b2c/interfaces/interfaces';
import {
  getEnableWciOnBookingConfirmation,
  getWciClosesOn,
  replacePlaceholders,
} from '@msc-b2c/shared-utils';
import {
  isDaysOfCheckinPassed,
  isStatusComplete,
  isWithinCheckInWindow,
} from '../../utils/checkinUtils';
import { WebCheckInStatusEnum } from '@msc-b2c/interfaces/enums';

export const removeSkeleton = () => {
  document.querySelector('.cmp-webcheckin-skeleton')?.remove();
};

export const removeAemPlaceholder = () => {
  document.querySelector('.webcheckin')?.remove();
};

/**
 * Determines the correct description text to show
 * depending on the check-in status and current date
 */
export const getCorrectDescription = (
  webCheckinDescriptionCurrentlyActive: string,
  webCheckinDescriptionActive: string,
  webCheckinDescriptionInactive: string,
  webCheckinDescriptionStatusComplete: string,
  daysBeforeDeparture: number,
  checkInStatus: CheckInsMyMSCResponse | null | undefined,
  checkinStartDate: { day: string; month: string; year: string }
) => {
  const wciClosesOn = getWciClosesOn();
  const hour = String(wciClosesOn ? wciClosesOn * 24 : 0);
  const day = String(wciClosesOn);

  if (
    !isStatusComplete(checkInStatus) &&
    (getEnableWciOnBookingConfirmation() || isWithinCheckInWindow(daysBeforeDeparture))
  ) {
    return replacePlaceholders(webCheckinDescriptionCurrentlyActive, {
      hour,
      day,
    });
  }

  if (!isStatusComplete(checkInStatus)) {
    if (isDaysOfCheckinPassed(daysBeforeDeparture)) {
      // Check-in is open
      return replacePlaceholders(webCheckinDescriptionActive, {
        hour,
        day: checkinStartDate.day,
        month: checkinStartDate.month,
        year: checkinStartDate.year,
      });
    } else {
      // Check-in is not open yet
      return replacePlaceholders(webCheckinDescriptionInactive, {
        hour,
        day,
      });
    }
  }
  // Description for Check status Complete
  return replacePlaceholders(webCheckinDescriptionStatusComplete, {
    day,
    hour,
  });
};

export const getCheckInStatus = (
  daysBeforeDeparture: number,
  checkInStatus: CheckInsMyMSCResponse | null | undefined
) => {
  if (!isStatusComplete(checkInStatus)) {
    if (isWithinCheckInWindow(daysBeforeDeparture)) {
      // Check-in is open
      return WebCheckInStatusEnum.INCOMPLETE;
    } else {
      // Check-in is not open yet
      return WebCheckInStatusEnum.UNAVAILABLE;
    }
  }
  // Description for Check status Complete
  return WebCheckInStatusEnum.COMPLETE;
};
